(function () {
  'use strict';
  if (window.__ylCartLoaded) return;
  window.__ylCartLoaded = true;

  // Mirror of the Shopify automatic bundle discounts (used only for the progress bar).
  var GROUPS = [
    { m: 'ringer-t-shirt', label: 'ringer tees', tiers: [[4, 1299], [3, 1199], [2, 849]] },
    { m: 'tie-dye-oversized-t-shirt', label: 'tie dye tees', tiers: [[3, 1949], [2, 1349]] },
    { m: 'co-ord-set-hoodies-joggers', label: 'hoodie sets', tiers: [[2, 2799]] },
    { m: 'acid-wash-oversized-tshirt', label: 'acid wash tees', tiers: [[3, 1919], [2, 1349]] },
    { m: 'flare-bootcut-trousers', label: 'bootcut trousers', tiers: [[3, 799], [2, 599]] }
  ];
  var inr = function (c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); };
  var inrN = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); };
  var pcache = {};
  function prod(handle) {
    if (!pcache[handle]) pcache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    return pcache[handle];
  }
  function eta() {
    var d = new Date(), n = 0;
    while (n < 5) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n++; }
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function tierPrice(qty, unit, tiers) {
    var best = 0;
    tiers.forEach(function (t) { if (qty >= t[0]) best = Math.max(best, t[0] * unit - t[1]); });
    return qty * unit - best;
  }
  function groupInfo(cart) {
    var out = [];
    GROUPS.forEach(function (g) {
      var items = cart.items.filter(function (i) { return i.handle.indexOf(g.m) !== -1; });
      var qty = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      if (!qty) return;
      var base = items.reduce(function (s, i) { return s + i.original_line_price; }, 0) / 100;
      var cur = items.reduce(function (s, i) { return s + i.final_line_price; }, 0) / 100;
      var unit = base / qty;
      var best = tierPrice(qty, unit, g.tiers);
      var save = Math.max(0, base - best);
      var already = base - cur;
      var steps = g.tiers.slice().reverse();
      var next = steps.filter(function (t) { return t[0] > qty; })[0];
      out.push({ g: g, qty: qty, save: Math.max(0, save - already), total: save, next: next, steps: steps });
    });
    return out;
  }

  class YlCartDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.backdrop = document.getElementById('yl-cart-backdrop');
      this.linesEl = this.querySelector('#ylcLines');
      this.cachedCart = null;
      this.pay = 'online';
      this.addEventListener('click', function (e) { self.onClick(e); });
      this.addEventListener('change', function (e) {
        var s = e.target.closest('[data-ylc-size]');
        if (s) { var b = s.parentNode.querySelector('[data-ylc-add]'); b.classList.toggle('is-ready', !!s.value); }
      });
      this.backdrop && this.backdrop.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.classList.contains('is-open')) self.close(); });
      var ap = this.querySelector('#ylDiscountApply'), inp = this.querySelector('#ylDiscountInput');
      var go = function () { var c = inp.value.trim(); if (c) location.href = '/discount/' + encodeURIComponent(c) + '?redirect=/checkout'; };
      ap && ap.addEventListener('click', go);
      inp && inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });
      this.refresh();
    }
    open() {
      this.classList.add('is-open'); this.setAttribute('aria-hidden', 'false');
      this.backdrop && this.backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    close() {
      this.classList.remove('is-open'); this.setAttribute('aria-hidden', 'true');
      this.backdrop && this.backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
    renderContents() { if (this.cachedCart) { if (!window.__yaQuiet) this.open(); } else this.refresh().then(function () { if (!window.__yaQuiet) document.querySelector('cart-drawer').open(); }); }
    refresh() {
      var self = this;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        self.cachedCart = cart; self.paint(cart); return cart;
      });
    }
    // Paint the added items straight from the /cart/add.js response, then reconcile
    // with one /cart.js call in the background (discounts, rounding).
    mergeAddedItems(data) {
      var self = this;
      if (!data) return false;
      var quiet = window.__yaQuiet;
      var added = Array.isArray(data.items) ? data.items : (data.id ? [data] : null), c = this.cachedCart;
      if (added && c) {
        added.forEach(function (it) {
          var ex = c.items.filter(function (i) { return i.key === it.key; })[0];
          if (ex) { ex.quantity = it.quantity; ex.line_price = it.line_price; ex.original_line_price = it.original_line_price; ex.final_line_price = it.final_line_price; }
          else c.items.unshift(it);
        });
        c.item_count = c.items.reduce(function (n, i) { return n + i.quantity; }, 0);
        c.original_total_price = c.items.reduce(function (n, i) { return n + i.original_line_price; }, 0);
        c.total_price = c.items.reduce(function (n, i) { return n + i.final_line_price; }, 0);
        c.total_discount = Math.max(0, c.original_total_price - c.total_price);
        this.paint(c);
      }
      if (!quiet && !this.classList.contains('is-open')) this.open();
      clearTimeout(this._t);
      this._t = setTimeout(function () { self.refresh(); }, 400);
      return true;
    }
    paint(cart) {
      this.classList.toggle('is-empty', cart.item_count === 0);
      var n = this.querySelector('[data-ylc-n]'); if (n) n.textContent = '(' + cart.item_count + ')';
      if (window.ylApp && window.ylApp.setCart) { try { window.ylApp.setCart(cart); } catch (e) {} }
      document.querySelectorAll('.ylh__cart-count').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count ? '' : 'none'; });
      this.renderLines(cart); this.renderTotals(cart); this.renderBundle(cart); this.renderUpsell(cart);
      var e = this.querySelector('[data-ylc-eta]'); if (e) e.textContent = eta();
    }
    renderLines(cart) {
      var self = this;
      this.linesEl.innerHTML = cart.items.map(function (i) {
        var size = (i.options_with_values || []).filter(function (o) { return /size/i.test(o.name); })[0];
        var other = (i.options_with_values || []).filter(function (o) { return !/size/i.test(o.name); }).map(function (o) { return esc(o.value); }).join(' · ');
        var sub = [other, size ? 'Size ' + esc(size.value) : ''].filter(Boolean).join(' · ');
        var props = i.properties ? Object.keys(i.properties).filter(function (k) { return k.charAt(0) !== '_' && i.properties[k]; }).map(function (k) { return esc(k) + ': ' + esc(i.properties[k]); }).join(' · ') : '';
        var disc = i.original_line_price > i.final_line_price;
        return '<div class="ylc-line yl-cart-line" data-key="' + esc(i.key) + '" data-q="' + i.quantity + '" data-h="' + esc(i.handle) + '" data-vid="' + i.variant_id + '">' +
          '<a class="ylc-line__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.product_title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="ylc-line__info"><div class="ylc-line__top"><div><a class="ylc-line__t" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a><div class="ylc-line__s">' + sub + '</div>' + (props ? '<div class="ylc-line__s">' + props + '</div>' : '') + '</div>' +
          '<button type="button" class="yl-cart-line__remove" data-ylc-rm aria-label="Remove"><svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button></div>' +
          '<div class="ylc-line__row"><div class="ylc-qty"><button type="button" data-ylc-dn aria-label="Decrease">−</button><span>' + i.quantity + '</span><button type="button" data-ylc-up aria-label="Increase">+</button></div>' +
          '<div class="ylc-line__p"><b>' + inr(i.final_line_price) + '</b>' + '<s data-mrp="' + i.original_line_price + '">' + (disc ? inr(i.original_line_price) : '') + '</s></div></div></div></div>';
      }).join('');
      // MRP strike from compare_at
      cart.items.forEach(function (i, idx) {
        prod(i.handle).then(function (p) {
          if (!p) return;
          var v = p.variants.filter(function (x) { return x.id === i.variant_id; })[0];
          var line = self.linesEl.querySelectorAll('.ylc-line')[idx];
          if (!v || !line) return;
          if (v.compare_at_price && v.compare_at_price > v.price) {
            line.querySelector('s').textContent = inr(v.compare_at_price * i.quantity);
            line.dataset.mrpTotal = v.compare_at_price * i.quantity;
            self.renderTotals(self.cachedCart);
          }
        });
      });
    }
    renderTotals(cart) {
      // Bundle savings are real Shopify discounts, already inside cart.total_price.
      var self = this, subOrig = cart.original_total_price, bs = 0;
      var mrp = 0;
      this.linesEl.querySelectorAll('.ylc-line').forEach(function (l) { mrp += +(l.dataset.mrpTotal || 0); });
      var q = function (s) { return self.querySelector(s); };
      q('[data-ylc-sub]').textContent = inr(subOrig);
      var bsr = q('[data-ylc-bs]'); bsr.hidden = !(bs > 0 || cart.total_discount > 0);
      q('[data-ylc-bsv]').textContent = '−' + inrN(bs + cart.total_discount / 100);
      var tot = cart.total_price - bs * 100;
      q('[data-ylc-tot]').textContent = inr(tot);
      var saved = bs * 100 + cart.total_discount + Math.max(0, mrp - cart.original_total_price);
      var sv = q('[data-ylc-sv]');
      sv.hidden = saved <= 0; sv.textContent = 'You\'re saving ' + inr(saved) + ' on this order';
      q('[data-ylc-co]').textContent = 'Checkout · ' + inr(tot);
    }
    renderBundle(cart) {
      var el = this.querySelector('#ylCartPromo'), gi = groupInfo(cart);
      if (!gi.length) { el.innerHTML = ''; return; }
      gi.sort(function (a, b) { return (a.next ? 0 : 1) - (b.next ? 0 : 1); });
      var x = gi[0], steps = x.steps, top = steps[steps.length - 1][0];
      var offer = steps.map(function (t) { return t[0] + ' for ' + inrN(t[1]); }).join(' · ');
      var pct = Math.min(100, x.qty / top * 100);
      var ticks = steps.slice(0, -1).map(function (t) { return '<u style="left:' + (t[0] / top * 100) + '%"></u>'; }).join('');
      var msg = x.next ? 'Add ' + (x.next[0] - x.qty) + ' more ' + x.g.label + ' to unlock ' + x.next[0] + ' for ' + inrN(x.next[1]) : (x.save > 0 || x.total > 0 ? 'Best deal unlocked — you save ' + inrN(x.total) : 'Best deal unlocked');
      el.innerHTML = '<div class="ylc-bundle__r"><b>Mix &amp; save on ' + esc(x.g.label) + '</b><span>' + offer + '</span></div><div class="ylc-bundle__bar"><i style="width:' + pct + '%"></i>' + ticks + '</div><div class="ylc-bundle__m">' + msg + '</div>';
    }
    renderUpsell(cart) {
      var self = this, el = this.querySelector('#ylCartUpsell');
      if (!cart.items.length) { el.innerHTML = ''; this._upKey = ''; return; }
      var pid = cart.items[0].product_id, ids = cart.items.map(function (i) { return i.product_id; });
      var key = ids.join(',');
      if (this._upKey === key) return;
      this._upKey = key;
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related').then(function (r) { return r.json(); }).then(function (d) {
        var ps = (d.products || []).filter(function (p) { return ids.indexOf(p.id) === -1 && p.available; }).slice(0, 2);
        if (!ps.length) { el.innerHTML = ''; return; }
        el.innerHTML = '<h3>Complete your order</h3><p>Pairs well with what\'s in your bag</p><div class="ylc-up__list">' + ps.map(function (p) {
          var szI = -1; (p.options || []).forEach(function (o, k) { if (/size/i.test(o.name || o)) szI = k; });
          var sizes = [], seen = {};
          p.variants.forEach(function (v) { if (!v.available) return; var s = szI >= 0 ? v['option' + (szI + 1)] : v.title; if (!seen[s]) { seen[s] = 1; sizes.push([s, v.id]); } });
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var cmp = p.compare_at_price > p.price ? '<s>' + inr(p.compare_at_price) + '</s>' : '';
          return '<div class="ylc-u"><img src="' + esc(img) + '" alt="" loading="lazy"><div><b>' + esc(p.title) + '</b><em>' + inr(p.price) + ' ' + cmp + '</em></div>' +
            '<select data-ylc-size aria-label="Size"><option value="">Size</option>' + sizes.map(function (s) { return '<option value="' + s[1] + '">' + esc(s[0]) + '</option>'; }).join('') + '</select>' +
            '<button type="button" data-ylc-add>Add</button></div>';
        }).join('') + '</div>';
      }).catch(function () { el.innerHTML = ''; });
    }
    post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    }
    onClick(e) {
      var self = this, t = e.target;
      var line = t.closest('.ylc-line');
      if (t.closest('[data-ylc-close]')) return this.close();
      if (t.closest('.yl-cart-drawer__close')) return this.close();
      if (t.closest('[data-ylc-up]') || t.closest('[data-ylc-dn]') || t.closest('[data-ylc-rm]')) {
        var q = +line.dataset.q, nq = t.closest('[data-ylc-up]') ? q + 1 : t.closest('[data-ylc-dn]') ? q - 1 : 0;
        this.post('/cart/change.js', { id: line.dataset.key, quantity: Math.max(0, nq) }).then(function () { return self.refresh(); });
        return;
      }
      if (t.closest('[data-ylc-add]')) {
        var row = t.closest('.ylc-u'), sel = row.querySelector('select');
        if (!sel.value) { sel.focus(); return; }
        var prevQ = window.__yaQuiet; window.__yaQuiet = true;
        this.post('/cart/add.js', { items: [{ id: +sel.value, quantity: 1 }] }).then(function () { window.__yaQuiet = prevQ; return self.refresh(); });
        return;
      }
      if (t.closest('[data-ylc-pin]')) { this.querySelector('#ylcPin').classList.toggle('is-on'); return; }
      if (t.closest('[data-ylc-pinok]')) {
        var v = this.querySelector('#ylcPinIn').value.trim();
        if (/^\d{6}$/.test(v)) { this.querySelector('[data-ylc-eta]').textContent = eta() + ' (PIN ' + v + ')'; this.querySelector('#ylcPin').classList.remove('is-on'); }
        return;
      }
      var pb = t.closest('[data-ylc-pay]');
      if (pb) {
        this.pay = pb.dataset.ylcPay;
        this.querySelectorAll('[data-ylc-pay]').forEach(function (b) { b.setAttribute('aria-pressed', b === pb ? 'true' : 'false'); });
        this.post('/cart/update.js', { attributes: { payment_preference: this.pay } });
      }
    }
  }
  customElements.define('cart-drawer', YlCartDrawer);

  var _f = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET').toUpperCase();
    var p = _f.apply(this, arguments);
    if (method === 'POST' && url.indexOf('/cart/add') !== -1) {
      p.then(function (res) {
        if (!res.ok) return;
        res.clone().json().then(function (d) { var dr = document.querySelector('cart-drawer'); if (dr) dr.mergeAddedItems(d); }).catch(function () {});
      });
    }
    return p;
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.action || f.action.indexOf('/cart/add') === -1) return;
    var dr = document.querySelector('cart-drawer'); if (!dr) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'), txt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Could not add to bag'); }); })
      .catch(function (err) { alert(err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = txt; } });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cart-drawer-toggle]')) return;
    e.preventDefault();
    var dr = document.querySelector('cart-drawer');
    if (dr) dr.refresh().then(function () { dr.open(); });
  });
})();